/* unplugin-vue-components disabled */import { render } from "./sample-uploader.vue?vue&type=template&id=147ebda0&scoped=true"
import script from "./sample-uploader.vue?vue&type=script&lang=js"
export * from "./sample-uploader.vue?vue&type=script&lang=js"

import "./sample-uploader.vue?vue&type=style&index=0&id=147ebda0&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-147ebda0"],['__file',"src/components/uploader/sample-uploader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "147ebda0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('147ebda0', __exports__)) {
    api.reload('147ebda0', __exports__)
  }
  
  module.hot.accept("./sample-uploader.vue?vue&type=template&id=147ebda0&scoped=true", () => {
    api.rerender('147ebda0', render)
  })

}


export default __exports__